module.exports = __webpack_public_path__ + "static/media/angry-icon.022ba941.svg";